import React from "react";

const STATUS_STYLES = {
  // ── Your original colors (unchanged) ──
  placed:                  { bg: "bg-yellow-100",  text: "text-yellow-800",  border: "border-yellow-200",  label: "Placed"                  },
  processing:              { bg: "bg-orange-100",  text: "text-orange-800",  border: "border-orange-200",  label: "Processing"              },
  packaging:               { bg: "bg-amber-100",   text: "text-amber-800",   border: "border-amber-200",   label: "Packaging"               },
  shipped:                 { bg: "bg-purple-100",  text: "text-purple-800",  border: "border-purple-200",  label: "Shipped"                 },
  returned:                { bg: "bg-orange-100",  text: "text-orange-800",  border: "border-orange-200",  label: "Returned"                },
  delivered:               { bg: "bg-green-100",   text: "text-green-800",   border: "border-green-200",   label: "Delivered"               },
  "cancelled-refunded":    { bg: "bg-blue-100",    text: "text-blue-800",    border: "border-blue-200",    label: "Cancelled + Refunded"    },
  "cancelled-notrefunded": { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Cancelled"               },
  rejected:                { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Rejected"                },

  // ── Added missing statuses (matching your color style) ──
  printing_started:        { bg: "bg-indigo-100",  text: "text-indigo-800",  border: "border-indigo-200",  label: "Printing Started"        },
  production_completed:    { bg: "bg-cyan-100",    text: "text-cyan-800",    border: "border-cyan-200",    label: "Production Completed"    },
  quality_check:           { bg: "bg-yellow-100",  text: "text-yellow-800",  border: "border-yellow-200",  label: "Quality Check"           },
  completed:               { bg: "bg-green-100",   text: "text-green-800",   border: "border-green-200",   label: "Completed"               },
  return_requested:        { bg: "bg-sky-100",     text: "text-sky-800",     border: "border-sky-200",     label: "Return Requested"        },
  return_approved:         { bg: "bg-teal-100",    text: "text-teal-800",    border: "border-teal-200",    label: "Return Approved"         },
  return_rejected:         { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Return Rejected"         },
  inspection_pending:      { bg: "bg-purple-100",  text: "text-purple-800",  border: "border-purple-200",  label: "Inspection Pending"      },
  inspection_passed:       { bg: "bg-green-100",   text: "text-green-800",   border: "border-green-200",   label: "Inspection Passed"       },
  inspection_failed:       { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Inspection Failed"       },
  refund_processing:       { bg: "bg-blue-100",    text: "text-blue-800",    border: "border-blue-200",    label: "Refund Processing"       },
  refunded:                { bg: "bg-green-100",   text: "text-green-800",   border: "border-green-200",   label: "Refunded"                },
  partial_refund:          { bg: "bg-amber-100",   text: "text-amber-800",   border: "border-amber-200",   label: "Partial Refund"          },
  replacement_processing:  { bg: "bg-sky-100",     text: "text-sky-800",     border: "border-sky-200",     label: "Replacement Processing"  },
  returned_no_refund:      { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Returned (No Refund)"    },
  cancellation_requested:  { bg: "bg-orange-100",  text: "text-orange-800",  border: "border-orange-200",  label: "Cancellation Requested"  },
  cancelled:               { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-200",     label: "Cancelled"               },
};

/* ── Normalize ANY incoming value to a STATUS_STYLES key ── */
const normalizeStatus = (raw = "") => {
  if (!raw) return "placed";

  // already a direct key
  if (STATUS_STYLES[raw]) return raw;

  const s = raw.toLowerCase().trim().replace(/ /g, "_");

  // direct key after transform
  if (STATUS_STYLES[s]) return s;

  const MAP = {
    "placed":                   "placed",
    "payment_pending":          "placed",
    "payment_success":          "placed",
    "order_created":            "placed",
    "processing":               "processing",
    "processing_started":       "processing",
    "paid":                     "processing",
    "printing_started":         "printing_started",
    "production_completed":     "production_completed",
    "quality_check":            "quality_check",
    "packaging":                "packaging",
    "packed":                   "packaging",
    "shipped":                  "shipped",
    "out_for_delivery":         "shipped",
    "delivered":                "delivered",
    "completed":                "completed",
    "return_requested":         "return_requested",
    "return_approved":          "return_approved",
    "return_pickup_scheduled":  "return_approved",
    "return_in_transit":        "return_approved",
    "return_rejected":          "return_rejected",
    "returned":                 "returned",
    "return_received":          "returned",
    "received_product":         "returned",
    "inspection_pending":       "inspection_pending",
    "inspection_passed":        "inspection_passed",
    "return_verified":          "inspection_passed",
    "inspection_failed":        "inspection_failed",
    "refund_processing":        "refund_processing",
    "refund_initiated":         "refund_processing",
    "refund":                   "refund_processing",
    "refunded":                 "refunded",
    "refund_completed":         "refunded",
    "refund_complete":          "refunded",
    "partial_refund":           "partial_refund",
    "replacement_processing":   "replacement_processing",
    "replacement":              "replacement_processing",
    "cancellation_requested":   "cancellation_requested",
    "cancel_requested":         "cancellation_requested",
    "cancelled":                "cancelled",
    "cancelled-refunded":       "cancelled-refunded",
    "cancelled_refunded":       "cancelled-refunded",
    "cancelled-notrefunded":    "cancelled-notrefunded",
    "cancelled_notrefunded":    "cancelled-notrefunded",
    "rejected":                 "rejected",
    "returned_no_refund":       "returned_no_refund",
  };

  return MAP[s] || MAP[raw.toLowerCase()];
};

const SIZE_CLASSES = {
  small:  "px-2 py-0.5 text-xs",
  medium: "px-3 py-1 text-sm",
  large:  "px-4 py-2 text-base font-medium",
};

const OrderStatusBadge = ({ status, size = "medium", className = "" }) => {
  const key = normalizeStatus(status);
  const cfg = STATUS_STYLES[key] || {
    bg:     "bg-gray-100",
    text:   "text-gray-700",
    border: "border-gray-200",
    label:  status || "Unknown",
  };

  return (
    <span className={`inline-flex items-center rounded-full border font-medium
      ${cfg.bg} ${cfg.text} ${cfg.border} ${SIZE_CLASSES[size] ?? SIZE_CLASSES.medium} ${className}`}
    >
      {cfg.label}
    </span>
  );
};

export default OrderStatusBadge;